// Module
var code = "<template> <div dt-grid-container> <require from=\"dashboard/my-tickets-widget\"></require> <my-tickets-widget></my-tickets-widget> </div> </template> ";
// Exports
export default code;